import React, { useEffect } from 'react';
import { PUBLIC_URL } from '../utils/const';
import AppLayout from '../layouts/AppLayout';
import { Head } from 'vite-react-ssg';
import Payment from './Payment';
import { Center, Loader } from '@mantine/core';

const Plan: React.FC = () => {
  const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
  if (params?.get('_ptxn')) {
    return <Payment />;
  }
  return <PlanRedirect />;
};

const PlanRedirect: React.FC = () => {
  useEffect(() => {
    window.location.replace(`${PUBLIC_URL}/dashboard?tab=plan`);
  }, []);

  return (
    <AppLayout include_navbar={false}>
      <Head>
        <title>Plan | Calensync</title>
        <meta name="description" content="Manage your Calensync subscription and your team" />
      </Head>
      <Center py="xl">
        <Loader />
      </Center>
    </AppLayout>
  );
};

export default Plan;
